export default "__VITE_ASSET__VawheCNS__"